<template>
  <TheLanding />
</template>

<script>
import TheLanding from '@/components/Landing/TheLanding.vue'

export default {
  name: 'HomePage',

  components: { TheLanding }
}
</script>
